import { render, staticRenderFns } from "./DeleteCustomViews.vue?vue&type=template&id=3accf600&"
import script from "./DeleteCustomViews.vue?vue&type=script&lang=js&"
export * from "./DeleteCustomViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports